/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import Modal from "../../../../components/common/Modal/Modal";
import Loader from "../../../../components/common/Loader/Loader";

export const APPOINTMENT_RADIO = {
  DID_COMMITTEE_MEET: "didCommitteeMeet",
  DID_YOU_PARTICIPATE: "didYouParticipate",
  DO_YOU_APPROVE_APPOINTMENT: "doYouApproveAppointment",
};

function ViewTemplate({ open, onClose, htmlData, isLoading }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{ maxHeight: "90%", minWidth: "30%" }}
    >
      {isLoading && <Loader />}
      <div>
        <Box>
          <Typography
            style={{
              color: "#8C8C8C",
              fontSize: "20px ",
              fontWeight: "500",
            }}
          >
            Email Template
          </Typography>
          <Box marginTop="30px" color="#183053">
            <Typography />
          </Box>
          <Box>
            <Paper
              style={{
                padding: "8px",
                borderRadius: "8px",
                backgroundColor: "#FAF9F6",
                maxHeight: "550px",
                overflowY: "auto",
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: htmlData?.data?.body }} />
            </Paper>
          </Box>
        </Box>
      </div>
    </Modal>
  );
}

export default ViewTemplate;
